import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import HorizontalRuleRoundedIcon from "@mui/icons-material/HorizontalRuleRounded";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import {
  APP_VIEW,
  DEPENDENT_FIELDS,
  DEPENDENT_FIELDS_CCM,
  REQUEST_STATUS,
  PRODUCT_TYPE_CATEGORIES,
  COUNTRY_CODE,
  ROLES,
  COUNTRY_CODE_MAP,
} from "../constants/constant";
import ReportIcon from "@mui/icons-material/Report";
import InfoIcon from "@mui/icons-material/Info";
import dayjs from "dayjs";
import { Chip } from "@mui/material";

export function getFromLocal(name) {
  return JSON.parse(window.localStorage.getItem(name));
}

export function setToLocal(name, data) {
  window.localStorage.setItem(name, JSON.stringify(data));
}

export function hasBPView(data) {
  return data?.businessRoles?.indexOf(APP_VIEW.BP) > -1;
}

export function hasCCMEdit(data) {
  return data?.businessRoles?.indexOf("EDIT_SAVE_CCM_VIEW") > -1;
}

export function hasBPEdit(data) {
  return data?.businessRoles?.indexOf("EDIT_SAVE_BP_VIEW") > -1;
}

export function hasProductEdit(data) {
  return data?.businessRoles?.indexOf("EDIT_PRODUCT_TYPE") > -1;
}

export function getUserRole(data) {
  return data?.userRole;
}

export function getUserCountry(data) {
  return COUNTRY_CODE_MAP[data?.country];
}

export function isEqual(obj1, obj2) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export function calculateDependent(data, field, original) {
  if (DEPENDENT_FIELDS[field]) {
    let netDueDate = dayjs(original["dueDateForNetPayment"], "YYYY-MM-DD");

    if (field === "newCalculatedDate") {
      let diff = dayjs(data[field], "YYYY-MM-DD").diff(netDueDate, "day", true);
      diff = diff === 0 ? 0 : Math.ceil(diff);
      data[DEPENDENT_FIELDS[field]] = diff;
    } else if (field === "daysOfExtension")
      data[DEPENDENT_FIELDS[field]] = netDueDate
        .add(data[field], "day")
        .format("YYYY-MM-DD")
        .toString();
    else if (field === "downPaymentPercentage") {
      data[DEPENDENT_FIELDS[field]] = parseFloat(
        original["amountInDocCurrency"]
          ? (original["amountInDocCurrency"] / 100) * data[field]
          : 0,
      ).toFixed(2);
    } else if (field === "downPaymentAmount") {
      data[DEPENDENT_FIELDS[field]] = parseInt(
        original["amountInDocCurrency"] && data[field]
          ? (data[field] / original["amountInDocCurrency"]) * 100
          : 0,
      );
    }
  }
  return data;
}

export function calculateDependentCCM(data, field, original) {
  if (DEPENDENT_FIELDS_CCM[field]) {
    let netDueDate = dayjs(original["dueDateForNetPayment"], "YYYY-MM-DD");

    if (field === "newCalculatedDate") {
      let diff = dayjs(data[field], "YYYY-MM-DD").diff(netDueDate, "day", true);
      diff = diff === 0 ? 0 : Math.ceil(diff);
      data[DEPENDENT_FIELDS_CCM[field]] = diff;
    } else if (field === "daysOfExtension")
      data[DEPENDENT_FIELDS_CCM[field]] = netDueDate
        .add(data[field], "day")
        .format("YYYY-MM-DD")
        .toString();
    else if (field === "downPaymentPercentage") {
      data[DEPENDENT_FIELDS_CCM[field]] = parseFloat(
        original["amountInDocCurrency"]
          ? (original["amountInDocCurrency"] / 100) * data[field]
          : 0,
      ).toFixed(2);
      data["amountToExtend"] = parseFloat(
        original["amountInDocCurrency"] && data[field]
          ? original["amountInDocCurrency"] - data[DEPENDENT_FIELDS[field]]
          : 0,
      ).toFixed(2);
    } else if (field === "downPaymentAmount") {
      data["amountToExtend"] = parseFloat(
        original["amountInDocCurrency"] && data[field]
          ? original["amountInDocCurrency"] - data[field]
          : 0,
      ).toFixed(2);
      // data[DEPENDENT_FIELDS_CCM[field]] = parseInt(original["amountInDocCurrency"] && data[field] ? ((data[field] / original["amountInDocCurrency"]) * 100): 0);
      data[DEPENDENT_FIELDS_CCM[field]] = parseInt(
        original["amountInDocCurrency"] && data[field]
          ? (data[field] / original["amountInDocCurrency"]) * 100
          : 0,
      );
    } else if (field === "amountToExtend") {
      data["downPaymentAmount"] = parseFloat(
        original["amountInDocCurrency"] && data[field]
          ? original["amountInDocCurrency"] - data[field]
          : 0,
      ).toFixed(2);
      data["downPaymentPercentage"] = parseInt(
        original["amountInDocCurrency"]
          ? (data["downPaymentAmount"] / original["amountInDocCurrency"]) * 100
          : 0,
      );
    }
  }
  return data;
}

export function validateField(item, isDate, record, field) {
  let error = [false, ""];

  if (item.attr && item.attr.validation) {
    if (item.value === 0 || (item.value !== "" && item.value)) {
      if (item.attr.validation.min === 0 || item.attr.validation.min) {
        if (isDate) error = checkDates(item, "min", record);
        else if (item.attr.validation.type === "percentage")
          error = checkPercentage(item, "min", record);
        else error = checkNumbers(item, "min", record);
      }

      if (
        !error[0] &&
        (item.attr.validation.max === 0 || item.attr.validation.max)
      ) {
        if (isDate) error = checkDates(item, "max", record);
        else if (item.attr.validation.type === "percentage")
          error = checkPercentage(item, "max", record);
        else error = checkNumbers(item, "max", record);
      }

      return error;
    } else {
      return [true, "Field cannot be empty"];
    }
  }

  return error;
}

export const getDateLimitValidation = (days, record) => {
  if (days[0] === "startDate") {
    return dayjs(record[days[0]], "YYYY-MM-DD");
  } else if (days[0] === "endDate") {
    return dayjs(record[days[0]], "YYYY-MM-DD");
  }
};

export const getDateLimit = (days, record) => {
  let date = dayjs();
  if (days) {
    if (days === "today") return date;
    if (days.constructor.name === "Array") {
      return dayjs(record[days[0]], "YYYY-MM-DD").add(days[1], "day");
    } else return date.add(days, "day");
  }
  return null;
};

const checkPercentage = (item, type, record) => {
  let limit = item.attr.validation[type];
  if (item.attr.validation[type].constructor.name === "Array") {
    limit =
      record[item.attr.validation[type][0]] > 0
        ? (record[item.attr.validation[type][0]] / 100) *
          item.attr.validation[type][1]
        : 0;
  }

  if (
    (type === "min" && item.value < limit) ||
    (type === "max" && item.value > limit)
  ) {
    if (item.attr.msg && item.attr.msg[type]) {
      return [false, item.attr.msg[type]];
    }

    return [true, item.attr.errorMsg[type]];
  }

  return [false, ""];
};

const checkDates = (item, type, record) => {
  let limit;
  if (item.item === "startDate" || item.item === "endDate") {
    limit = getDateLimitValidation(item.attr.validation[type], record);
  } else {
    limit = getDateLimit(item.attr.validation[type], record);
  }

  if (
    limit &&
    ((type === "min" && dayjs(item.value).diff(limit) < 0) ||
      (type === "max" && dayjs(item.value).diff(limit) > 0))
  ) {
    if (item.attr.msg && item.attr.msg[type]) {
      return [false, item.attr.msg[type]];
    }

    return [true, item.attr.errorMsg[type]];
  }

  return [false, ""];
};

const checkNumbers = (item, type, record) => {
  let limit = item.attr.validation[type];
  if (item.attr.validation[type].constructor.name === "Array") {
    limit = record[item.attr.validation[type][0]];
  }

  if (
    (type === "min" && item.value < limit) ||
    (type === "max" && item.value > limit)
  ) {
    if (item.attr.msg && item.attr.msg[type]) {
      return [false, item.attr.msg[type]];
    }

    return [true, item.attr.errorMsg[type]];
  }

  return [false, ""];
};

const getStausIcon = (value, creditLimitExceeded = false) => {
  // Show warning icon for System_CCM with credit limit exceeded
  // if (value === REQUEST_STATUS.system_ccm && creditLimitExceeded) {
    if (creditLimitExceeded ){
    return (
      <ReportProblemRoundedIcon
        style={{ fontSize: "large", color: "rgb(249, 151, 0)" }}
      />
    );
  }
  if (value === REQUEST_STATUS.pending)
    return (
      <HourglassBottomIcon style={{ fontSize: "large", color: "#7A4300" }} />
    );
  else if (
    value === REQUEST_STATUS.system_bp ||
    value === REQUEST_STATUS.system_ccm ||
    value === REQUEST_STATUS.bp_to_ccm ||
    value === REQUEST_STATUS.ccm_to_bp ||
    value === REQUEST_STATUS.manual_new
  )
    return (
      <HorizontalRuleRoundedIcon
        style={{
          fontSize: "large",
          color: value === REQUEST_STATUS.manual_new ? "#7A4300" : "#F99700",
        }}
      />
    );
  else if (
    value === REQUEST_STATUS.system_reject ||
    value === REQUEST_STATUS.ccm_reject ||
    value === REQUEST_STATUS.system_rejected_by_ccm ||
    value === REQUEST_STATUS.bp_reject ||
    value === REQUEST_STATUS.system_exclude ||
    value === REQUEST_STATUS.system_bp_exclude ||
    value === REQUEST_STATUS.system_include_exclude
  )
    return (
      <CancelRoundedIcon style={{ fontSize: "large", color: "#C21020" }} />
    );
  else if (
    value === REQUEST_STATUS.system_approved ||
    value === REQUEST_STATUS.auto_approved ||
    value === REQUEST_STATUS.bp_approved ||
    value === REQUEST_STATUS.ccm_approved ||
    value === REQUEST_STATUS.system_approved_by_bp ||
    value === REQUEST_STATUS.system_include ||
    value === REQUEST_STATUS.system_bp_include ||
    value === REQUEST_STATUS.bp_booked ||
    value === REQUEST_STATUS.system_exclude_include
  )
    return (
      <CheckCircleRoundedIcon style={{ fontSize: "large", color: "#367C2B" }} />
    );
  else if (value === REQUEST_STATUS.error || value === REQUEST_STATUS.manual_error) {
    return <ReportIcon style={{ fontSize: "large", color: "white" }} />;
  } else if (
    value === REQUEST_STATUS.not_processed_by_fs ||
    value === REQUEST_STATUS.not_processed_by_fs_bp
  ) {
    return <InfoIcon style={{ fontSize: "large", color: "#005DB1" }} />;
  }
};

export function getStatusCell(status, options = {}) {
  let value = status.toLowerCase();
  const { creditLimitExceeded = false } = options;
  
  // Add credit-limit-exceeded class for System_CCM with credit limit exceeded
  // const additionalClass = (value === REQUEST_STATUS.system_ccm && creditLimitExceeded) 
  //   ? " credit-limit-exceeded" 
  //   : "";
  
  return (
    <Chip
      className={"record-status " + value }
      label={status.replaceAll("_", " ")}
      icon={getStausIcon(value, creditLimitExceeded)}
    />
  );
}

export function getCurrencyCell(
  currencyKey
) {
  return (
    <span style={{ display: "flex", justifyContent: "space-between" }}>
      <span>{currencyKey}</span>
    </span>
  );
}

export function getAmountCell(
  amountInDocCurrency,
  debitCreditIndicator,
) {
  return (
    <span style={{ display: "flex", justifyContent: "space-between" }}>
      <span>
        {debitCreditIndicator === "H" ? "-" : ""}
        {parseFloat(amountInDocCurrency).toFixed(2).toLocaleString("de-DE")}
      </span>
    </span>
  );
}

export function getDateCell(dueDateForNetPayment) {
  // return dayjs(cell.getValue(), "YYYY-MM-DD").format("DD-MM-YYYY").toString();
  return dayjs(dueDateForNetPayment, "YYYY-MM-DD")
    .format("DD-MM-YYYY")
    .toString();
}

export function checkErrorMsg(error) {
  if (error?.response?.data?.message) {
    return error.response.data.message;
  } else {
    return false;
  }
}

export function getProductType(data) {
  return PRODUCT_TYPE_CATEGORIES[data];
}

export function getCountryCode(data) {
  return COUNTRY_CODE[data];
}

export function getHighRisk(data) {
  return data === "Yes" ? true : false;
}

export function canBPReject(extensionType) {
  if (
    extensionType === "LO" ||
    extensionType === "RR" ||
    extensionType === "LD" ||
    extensionType === "TD" ||
    extensionType === "EF"
  ) {
    return true;
  }
  return false;
}

export function canBPApprove(extensionType) {
  if (
    extensionType === "RR" ||
    extensionType === "LD" ||
    extensionType === "TD"
  ) {
    return false;
  }
  return true;
}

export function getCCMCountries(country, userid) {
  if (userid === "ou34ham" || userid === "jl60084" || userid === "sv457a2") {
    return ["BE", "CZ", "NL"];
  } else if (country === "BE" || country === "CZ" || country === "NL") {
    return ["BE", "CZ", "NL"];
  } else if (country === "ES" || country === "PT") {
    return ["ES", "PT"];
  } else if (country === "GB" || country === "IE" || country === "PL") {
    return ["GB", "IE", "PL"];
  } else {
    return [country];
  }
}

export function getCCMCountriesforReport(country, userid) {
  if (country === "ES" || country === "PT") {
    return ["ES", "PT"];
  } else if (country === "GB" || country === "IE" || country === "PL") {
    return ["GB", "IE", "PL"];
  } else {
    return [country];
  }
}

export function isActionVisible(view, userData) {
  if (view === APP_VIEW.BP && getUserRole(userData) === ROLES.BP) {
    return true;
  } else if (view === APP_VIEW.CCM && getUserRole(userData) === ROLES.CCM) {
    return true;
  } else {
    return false;
  }
}
